import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSupport = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "ç¼ç»",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "è·¯å¾",
				d: "M14.9999 13.3332V13.3332C16.8409 13.3332 18.3333 11.8408 18.3333 9.99984C18.3333 8.15889 16.8409 6.6665 14.9999 6.6665",
				stroke: "",
				strokeWidth: 1.66667,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "è·¯å¾_2",
				d: "M4.99996 6.6665C3.15901 6.6665 1.66663 8.15889 1.66663 9.99984C1.66663 11.8408 3.15901 13.3332 4.99996 13.3332V13.3332",
				stroke: "",
				strokeWidth: 1.66667,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "è·¯å¾_3",
				d: "M4.99994 13.3332V13.1248V12.0832V9.99984V6.6665C4.99994 3.90508 7.23852 1.6665 9.99994 1.6665C12.7614 1.6665 14.9999 3.90508 14.9999 6.6665V13.3332C14.9999 16.0946 12.7614 18.3332 9.99994 18.3332",
				stroke: "",
				strokeWidth: 1.66667,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgSupport;
